import React, {useEffect, useState} from 'react';
import { DualAxes, G2} from '@ant-design/plots';
import {DatePicker, Select} from "antd";
import {API_PATH, MODEL_PATH} from "../../components/const";
import axios from "axios";
import dayjs from "dayjs";
import { each, groupBy } from '@antv/util';
import {tr} from "date-fns/locale";
import {toast} from "react-toastify";
import * as XLSX from "xlsx";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
const Visitor = () => {

    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    // const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);

    const [prognoz, setPrognoz] = useState({});
    const [model, setModel] = useState({});
    const dateFormat = 'YYYY-MM';
    // const [dataLine, setDataLine] = useState([])
    const event = new Date();
    const [offices, setOffices] = useState([])
    const [parents, setParents] = useState([])
    const [rooms, setRooms] = useState([])
    const [cameras, setCameras] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [selectRooms, setSelectRooms] = useState(null)
    const [selectCameras, setSelectCameras] = useState("")
    const [sendData, setSendData] = useState(null)
    const [smart_camera_ids, setsmart_camera_ids] = useState([])



    const [data, setData] = useState([
        {
            type: 'female',
            value: 0,
            date: "2023-12-12"
        },
        {
            type: 'male',
            value: 0,
            date: "2023-12-12"
        },
    ])
    const [dataLine, setDataLine] = useState([
        {
            type: 'group',
            value: 0,
            date: "2023-12-12"
        }
    ])
    event.setHours(event.getHours() + 1);

    function onChange(date, dateString) {
        setShow(false)

        if (dateString.length > 0) {
            const cameraIdsParam = (smart_camera_ids?.length > 0) ? "&smart_camera_ids=" + encodeCommas(smart_camera_ids) : "";
            fetch(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/gender-and-group/monthly-breakdown?year=" + dateString.slice(0, 4) + "&month=" + Number(dateString.slice(5, 7)) + cameraIdsParam, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((response) => response.json())
                .then((json) => {
                        setData(json?.filter(item => item?.type !== 'group')?.map(item => {
                            return {
                                ...item,
                                type: item?.type === "male" ? "Мужской" : item?.type === "female" ?  "Женский" : item?.type === "group" ? "group": item?.type === "forecast" ? "Прогноз" : "",
                                // name: item?.type === "male" ? "Пол" : item?.type === "female" ?  "Пол" : item?.type === "forecast" ? "Прогноз" : "",
                            }
                        }))

                        setDataLine(json?.filter(item => item?.type === 'group')?.map(item => {
                            return {
                                ...item,
                                type: "Лид",
                            }
                        }))

                        setTimeout(() =>{
                            setShow(true)

                        }, 400)
                    }

                )
                .catch((error) => {

                });
        } else {
            asyncFetch(smart_camera_ids || []);
        }
    }
    const getBuilding = (val,e) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                setSendData({...sendData, buildings_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getRooms = (id) => {
        getCameras(id)
        setSelectOffices(id)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/room/" + id + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRooms(res.data?.items)
                setSendData({...sendData, room_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getCameras = (id) => {
        setSelectRooms(id)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all?building_id=" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getCamerasSearch = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all?building_id=" + selectRooms + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        window.scrollTo(0, 0);
    }
    function encodeCommas(str) {
        // Split the string by commas
        let text = str.toString();
        const parts = text?.split(',');

        // Encode each part individually
        const encodedParts = parts.map(part => encodeURIComponent(part));

        // Join the encoded parts back together with commas
        return encodedParts.join('%2C');
    }
    const asyncFetch = (e) => {
        setShow(false)
        fetch(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/gender-and-group/monthly-breakdown?year=" + year + "&month=" + Number(month + 1) +  "&smart_camera_ids="  + encodeCommas(e) , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then((response) => response.json())
            // .then((json) => setData(json.map(item => {return {...item, date2: item.date.slice(5, 7)}})))
            .then((json) => {

                setData(json?.filter(item => item?.type !== 'group')?.map(item => {
                    return {
                        ...item,
                        type: item?.type === "male" ? "Мужской" : item?.type === "female" ?  "Женский" : item?.type === "group" ? "group": item?.type === "forecast" ? "Прогноз" : "",
                        // name: item?.type === "male" ? "Пол" : item?.type === "female" ?  "Пол" : item?.type === "forecast" ? "Прогноз" : "",

                    }
                }))
                setDataLine(json?.filter(item => item?.type === 'group')?.map(item => {
                    return {
                        ...item,
                        type: "Лид",
                    }
                }))

                setTimeout(() =>{
                    setShow(true)
                }, 400)
                }

            )
            .catch((error) => {
            });
    };


    const config = {
        data: [data, dataLine],
        xField: 'date',
        type: 'type',
        yField: ['value', 'value'],
        // color:[[ '#FC53F5','#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],[ '#FC53F5','#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C']],
        point: {
            size: 5,
            shape: 'diamond',
            style: {
                fill: 'white',
                stroke: '#5B8FF9',
                lineWidth: 2,
            },
        },
        meta: {
            value: {
                alias: 'Лид',
            },
        },
        geometryOptions: [
            {
                geometry: 'column',
                isStack: true,
                seriesField: 'type',
                columnWidthRatio: 0.4,
                groupField: 'name',
                label: {},
                color:[ '#FC53F5','#5664D2'],
            },
            {
                geometry: 'line',
                color:'#00E480',
            },
        ],
        interactions: [
            {
                type: 'element-highlight',
            },
            {
                type: 'active-region',
            },
        ],
        animation: false,
        theme: 'custom-theme',
    };
    const [groupedData, setGtosfp] = useState([])
    const reoa = () => {
            setGtosfp(data.reduce((acc, item) => {
            if (!acc[item.date]) {
                acc[item.date] = { Мужской: 0, Женский: 0 };
            }
            acc[item.date][item.type] = item.value;
            return acc;
        }, {}) )
    }
    const getPrognoz = () => {
        axios.post(MODEL_PATH + "age-prediction-hourly-v1"  , [
            {
                "company_type": localStorage.getItem("company_type"),
                "hour_of_day": event?.getHours(),
                "day_of_week": time.getDay()
            }
        ], {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setPrognoz(res?.data?.predictions[0])
                setModel(res?.data?.model)
            })
            .catch(err =>{

        })
    }

    const exportToExcel = () => {
            const formattedData = Object.entries(data.reduce((acc, item) => {
                if (!acc[item.date]) {
                    acc[item.date] = { Мужской: 0, Женский: 0 };
                }
                acc[item.date][item.type] = item.value;
                return acc;
            }, {})).map(([date, values]) => ({
                "№": date,
                "Мужской": values.Мужской,
                "Женский": values.Женский
            }));
            // Jadvalni Excel formatiga aylantirish
            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");

            // Faylni saqlash
            XLSX.writeFile(workbook, "table_data.xlsx");

    };

    useEffect(() => {
        asyncFetch([]);
        // getPrognoz()
        getBuilding()
        getParentBuilding()

    }, []);
    return (
        <div className="visitor visitor-box">
            {/*<div className="chart-box text-white mb-3">*/}
            {/*    <span className="text-white">*/}
            {/*        Согласно анализу ИИ, сегодня в <span className="text-success">{prognoz?.hour}:00</span> в вашей компании ждут <span className="text-success">{prognoz?.visitor_count}</span> человек средним возрастом <span className="text-success">{Math.floor(Number(prognoz?.average_age))}</span> лет.*/}
            {/*    </span>*/}
            {/*    <span className="text-white d-block mt-3">*/}
            {/*        Информация о модели: модель обучена {model?.training_date?.slice(0, 10)} в {model?.training_date?.slice(11, 16)} с размером данных {model?.dataset_size}.*/}
            {/*    </span>*/}
            {/*</div>*/}
            <div className="chart-box">

                <div className="visitor-title  d-flex justify-content-between align-items-center visitor-box-item-media">
                    <h1 className='m-0'>
                        <span>
                       Посетители
                  </span>
                  </h1>
                    <div className="d-flex align-items-end my-multi-select">
                        <div className="inputs-box mr-16 remove-back-select" style={{minWidth: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите раздел"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getParentBuilding}
                                onChange={(e) => getBuilding(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={parents?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>
                        <div className="inputs-box mr-16 remove-back-select" style={{minWidth: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите филиал"
                                optionFilterProp="children"
                                className="w-100"
                                // onSearch={getBuilding}
                                onChange={(e) => getRooms(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={offices?.map((item) => {
                                    return {
                                        value: item.building_id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>

                        <div className="inputs-box mr-16" style={{minWidth: "200px"}}>
                            <Select
                                showSearch
                                mode="multiple"

                                placeholder="Выберите камера"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getCamerasSearch}
                                onChange={(e) => {
                                    setsmart_camera_ids(e)
                                    asyncFetch(e)
                                }}
                                // onChange={(e) => setCountry(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={cameras?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.name
                                    };
                                })}
                            />
                        </div>

                        <DatePicker picker="month"
                                    defaultValue={dayjs(year + "-" + (month < 9  ? "0" : "") + Number(month + 1), dateFormat)}
                                    onChange={onChange}
                                    placeholder="Выберите месяц"
                                    format={dateFormat}
                        />
                    </div>
                   
                 
                </div>

                {
                    show
                    ?
                        <DualAxes {...config} />
                        :
                        ""
                }


                <div className="emp-table mt-4 ">
                    <div className="d-flex justify-content-between">
                        <button type="submit" className="add-btn mb-3" onClick={() => {
                            setShow2(!show2)
                            reoa()
                        }}>Посмотреть таблицу</button>
                        <button type="submit" className="btn btn-success mb-3" onClick={exportToExcel}>Скачать таблицу</button>
                    </div>


                    {
                        show2
                            ?
                            <TableContainer component={Paper}>
                                <Table sx={{minWidth: 650}} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className="pl20 table-head">№</TableCell>
                                            <TableCell className="  table-head">Мужской</TableCell>
                                            <TableCell className="table-head" >Женский</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {Object.entries(groupedData).map(([date, values], index) => (
                                        <TableRow key={date}>
                                            <TableCell className="text-white">{date}</TableCell>
                                            <TableCell className="text-white">{values.Мужской}</TableCell>
                                            <TableCell className="text-white">{values.Женский}</TableCell>
                                        </TableRow>
                                    ))}
                                </Table>
                            </TableContainer>

                            :
                            ""
                    }
                </div>

            </div>



        </div>
    );
};

export default Visitor;